import styled from 'styled-components';

import { GeneralInfo, UpdateMessage } from 'libs/ui';
// import TariffsGrid from '../grid/Grid';

export const StatusBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TariffGeneralInfo = styled(GeneralInfo)`
  height: 140px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: ${(props) => props.align};
`;

export const NameTarifficator = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.p`
  font-size: 26px;
  color: #fff;
`;
export const TransportClass = styled.p`
  font-size: 15px;
  line-height: 1.73;
  color: #fff;
  max-width: 840px;
`;
export const OtherInfo = styled.div`
  span {
    font-size: 15px;
    line-height: 1.73;
    color: #fff;
    &:first-child {
      margin-right: 40px;
      font-weight: bold;
    }
  }
`;

// export const StyledTariffsGrid = styled(TariffsGrid)`
//   tbody th,
//   tbody {
//     &:last-child {
//       border: solid 1px #393e44;
//       td {
//         border-bottom: 0px;
//       }
//     }
//   }
//   position: relative;
//   top: 1px;
//   width: 99.99%;
// `;

export const UpdateMessageBox = styled(UpdateMessage)`
  bottom: -100px;
  left: 180px;
  width: 270px;
`;

export const Status = styled.div`
  color: ${(props) => (props.status === 'active' ? '#00fe8e' : '#fff')};
`;

export const TariffManageWrapper = styled.div`
  width: 100%;
  form {
    position: relative;
    display: flex;
    //justify-content: space-between;
    align-items: flex-start;
  }
`;
